import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { ELanguage, changeLanguage } from "../i18n"

export const LangSelector = () => {
    const { i18n } = useTranslation()
    const history = useHistory()
    const currentLang = i18n.language

    return (
        Object.values(ELanguage).map((lang) => (
            <a
                key={lang}
                onClick={() => changeLanguage(i18n, lang, history)}
                className={"li hover-text-underline cursor mx-2 " + (currentLang == lang ? "d-none" : null)}
            >
                {lang.toUpperCase()}
            </a>
        ))
    )
}